/**
 * Maximum character limits for notification text fields, grouped by field type.
 *
 * Can check old rules against these limits using the `checkReqApproval` script (in api/scripts), which queries
 * the database for any rules that exceed these limits and logs them for review.
 */
const NOTIFICATION_LIMITS = {
  /** Call to Action Label */
  CTA_LABEL: 54,
  TITLE: 115,
  SUBJECT_TAG: 100,
  EMAIL_SUBJECT: 150,
  MESSAGE: 500,
  BODY_TEXT: 1500,
  HTML_LAYOUT: 7500,
};

module.exports = { NOTIFICATION_LIMITS };
